module.exports = __webpack_public_path__ + "img/a0ce58d.jpg";